module.exports = __webpack_public_path__ + "assets/img/eleventh_three.e3da4823.png";